export default __webpack_public_path__ + "static/media/icon_fotografias.6572d185.svg";